import { JSX } from "react/jsx-runtime"
import './ComboBoxComponent.scss'

interface ComboBoxComponentProps {
    options: Map<string, any>
    id: string
    name: string
    label: string
    labelClass?: string
    onChange: (value: string) => void
    defaultValue?: string,
    placeholder?: string,
}

const ComboBoxComponent: React.FC<ComboBoxComponentProps> =
    ({id, name, label, options, labelClass, onChange, defaultValue, placeholder}: ComboBoxComponentProps) => {

    const createOptions = () => {
        const optionElements: JSX.Element[] = []
        if (placeholder) {
            optionElements.push(
                <option key={`${id}-${placeholder}`} value="" selected={true}>{placeholder}</option>
            )
        }
        options.forEach(((option, key) => {

            optionElements.push(
                (
                    <option key={key} value={option} selected={placeholder ? false : defaultValue === option}>{option}</option>
                )
            )
        }))
        return optionElements
    }

    return (
        <div className="combobox-container">
            <div
                className={`${labelClass ? labelClass : ""} font-sm input-label flex-start primary-color`}>
                {label}
            </div>
            <select name={name} id={id}
                    className="font-md-plus primary-font-color input full-border-radius secondary-color-border combobox background-white font-black"
                    defaultValue={defaultValue}
                    onChange={(event) => onChange(event.target.value)}>
                {createOptions()}
            </select>
        </div>

    )
}

export default ComboBoxComponent